var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form-layout',{attrs:{"title":"Select Part (Inventory)","size":"large"},on:{"submit":_vm.onSubmit}},[_c('v-form',{ref:"form"},[_c('ItemUnitsOnProductEditForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }